import { useState, useEffect } from 'react';
import SuperAdminSidebar from './SuperAdminSidebar';
import SuperAdminHeader from './SuperAdminHeader';

const SuperAdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  
  // Mobil kontrolü
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024; // lg breakpoint
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false); // Mobilde varsayılan olarak kapalı
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return (
    <div className="flex flex-col h-screen bg-white dark:bg-gray-900">
      <SuperAdminHeader 
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        isMobile={isMobile}
      />
      
      <div className="flex flex-1 overflow-hidden relative">
        <SuperAdminSidebar 
          isOpen={isSidebarOpen} 
          onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
          onCloseSidebar={() => setIsSidebarOpen(false)}
          isMobile={isMobile}
        />
        
        {/* Mobilde overlay */}
        {isMobile && isSidebarOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
        
        <main className={`
          flex-1 
          bg-[#f0f2f5] dark:bg-gray-800
          overflow-hidden
          transition-all 
          duration-300 
          px-3 sm:px-6
          pt-3 sm:pt-6
          pb-3 sm:pb-6
          ${!isMobile ? (isSidebarOpen ? 'ml-[290px]' : 'ml-[50px]') : 'ml-0'}
        `}>
          <div className={`
            w-full 
            h-full
            bg-white dark:bg-gray-800
            rounded-[5px] 
            shadow-[0_2px_4px_rgba(0,0,0,0.05)] 
            p-6
            overflow-auto
            transition-all 
            duration-300
          `}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
